module.exports = __webpack_public_path__ + "img/Comments.f0a010c1.png";